import { useQuery } from '@tanstack/react-query';

import { useLivescoresStore } from '../store';

import type { BroadcastersParams } from '@queries/broadcasters';
import { getBroadcastersQuery } from '@queries/broadcasters';

const useLivescoresBroadcasters = (options: BroadcastersParams, loadBroadcasters: boolean) => {
  const country = useLivescoresStore((state) => state.broadcastCountry);

  const { data: broadcasters } = useQuery({
    ...getBroadcastersQuery({
      ...options,
      countryCode: country?.countryCodeShort,
      regionCode: country?.regionCodeShort,
    }),
    enabled: !!loadBroadcasters,
  });

  return loadBroadcasters ? broadcasters : [];
};

export default useLivescoresBroadcasters;
